<div class="employer-list-page">
  <app-page-cardhead style="margin-top: -1.1rem" [PageName]="'Employer Correction'" [PageHeadWidth]="600"></app-page-cardhead>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-indicator text-center my-3">
    <i class="fas fa-spinner fa-spin me-2"></i>Loading employers...
  </div>

  <!-- Error message -->
  <div *ngIf="errorMessage" class="alert alert-danger mx-auto employer-correction-container">
    {{ errorMessage }}
  </div>

  <div *ngIf="!isLoading" class="card shadow-sm mx-auto employer-correction-container">
    <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between flex-wrap gap-2">
      <h5 class="mb-0">Employer Name Corrections</h5>

      <!-- Summary banner -->
      <div class="d-flex align-items-center gap-2">
        <span class="badge bg-light text-dark">Total: {{ summary.total }}</span>
        <span class="badge bg-success">Succeeded: {{ summary.succeeded }}</span>
        <span class="badge bg-danger">Failed: {{ summary.failed }}</span>
      </div>
    </div>

    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div class="d-flex align-items-center flex-wrap gap-2">
          <mdb-select class="select" style="width: 180px;" [(ngModel)]="loadMode" name="loadMode"
            aria-label="Employer load mode">
            <mdb-option [value]="'serial'">Load by serial</mdb-option>
            <mdb-option [value]="'name'">Search by name</mdb-option>
          </mdb-select>
          <div style="max-width: 320px;">
            <input type="search" class="form-control" [placeholder]="loadMode === 'serial' ? 'Branch serial' : 'Employer name'"
              [(ngModel)]="loadValue" name="loadValue" (keyup.enter)="loadEmployersByCriteria()" />
          </div>
          <button type="button" class="btn btn-primary" [disabled]="isLoading || !loadValue.trim()"
            (click)="loadEmployersByCriteria()">
            <i class="fas fa-search me-1"></i>Load
          </button>
          <div style="max-width: 320px;">
            <input type="search" class="form-control" placeholder="Filter loaded results"
              [(ngModel)]="searchText" name="searchText" />
          </div>
        </div>

        <button type="button" class="btn btn-primary rounded-pill" [disabled]="!canApplySelected"
          (click)="applySelected()">
          <i class="fas fa-check-double me-1"></i>
          Correct All Selected ({{ selectedRows.length }})
        </button>
      </div>

      <!-- CSV upload -->
      <div class="csv-upload d-flex align-items-center flex-wrap gap-2 mb-3 p-2 border rounded bg-light">
        <label for="csvFile" class="fw-bold mb-0 me-1">Upload employer corrections (CSV):</label>
        <input id="csvFile" type="file" accept=".csv" class="form-control form-control-sm"
          style="max-width: 280px;" [disabled]="isCsvProcessing" (change)="onCsvFileSelected($event)" />
        <span *ngIf="isCsvProcessing" class="text-muted"><i class="fas fa-spinner fa-spin me-1"></i>Processing...</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="downloadCsvTemplate()">
          <i class="fas fa-download me-1"></i>Download template
        </button>
        <span *ngIf="skippedRowCount > 0" class="badge bg-warning text-dark"
          [title]="csvWarnings.join('\n')">
          {{ skippedRowCount }} row(s) skipped
        </span>
      </div>

      <div class="table-responsive">
        <lms-table-wrapper class="center-screen mb-1" [items]="filteredRows" [config]="config">
          <table class="table table-striped table-auto table-hover table-borderless shadow-sm rounded align-middle">
            <thead class="table-primary">
              <tr>
                <th style="width: 3rem;">
                  <input type="checkbox" class="form-check-input" [checked]="isAllSelected"
                    (change)="toggleSelectAll($any($event.target).checked)" title="Select all modified rows" />
                </th>
                <th>Branch Serial</th>
                <th>TNumber</th>
                <th>Current Name (Incorrect)</th>
                <th>Corrected Name</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filteredRows | paginate: config">
                <td>
                  <input type="checkbox" class="form-check-input" [(ngModel)]="row.selected"
                    [ngModelOptions]="{ standalone: true }" [disabled]="row.status !== 'modified'" />
                </td>
                <td>{{ row.serial }}</td>
                <td>{{ row.tnumber }}</td>
                <td>{{ row.name }}</td>
                <td>
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="row.correctedSpelling"
                    [ngModelOptions]="{ standalone: true }" (change)="onCorrectedNameChange(row)"
                    [disabled]="row.status === 'updating'" lmsNoSpecials toUppercase />
                </td>
                <td>
                  <span class="badge bg-warning text-dark" *ngIf="row.status === 'modified'" title="Pending / modified">
                    <i class="fas fa-hourglass-half me-1"></i>Pending
                  </span>
                  <span class="badge bg-info text-dark" *ngIf="row.status === 'updating'" title="Updating...">
                    <i class="fas fa-sync-alt fa-spin me-1"></i>Updating...
                  </span>
                  <span class="badge bg-success" *ngIf="row.status === 'success'" [title]="row.message || 'Success'">
                    <i class="fas fa-check me-1"></i>Synced
                  </span>
                  <span class="badge bg-danger" *ngIf="row.status === 'failed'" [title]="row.message || 'Failed'">
                    <i class="fas fa-times me-1"></i>Failed
                  </span>
                  <span class="badge bg-secondary" *ngIf="row.status === 'unmodified'" title="No changes">
                    Unchanged
                  </span>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-outline-primary rounded-pill"
                    [disabled]="row.status !== 'modified'" (click)="applyCorrection(row)">
                    Apply Correction
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredRows.length === 0">
                <td colspan="7" class="text-center text-muted py-3">No employers found.</td>
              </tr>
            </tbody>
          </table>
        </lms-table-wrapper>
      </div>
    </div>
  </div>
</div>
